import React from 'react';

const FaNum = ({children}) => {
    return (
        <span style={{fontFamily:'IRANSansFaNum'}}> {children}</span>
    );
};

export default FaNum;